import { apiAddress } from "../../config/server";
import { IShiftSession } from "../../types/shifts/Shift";
import { ApiBase } from "./baseApi";

export default class ShiftSessionsApi extends ApiBase {
  static ShiftSessionsApiAddress = `${apiAddress}/api/shift/sessions/`;

  static getById(sessionId: string): Promise<IShiftSession> {
    return this.get<IShiftSession>(
      this.ShiftSessionsApiAddress + sessionId,
    ).then((response) => response.data.data);
  }

  static getByShiftId(shiftId: string): Promise<IShiftSession[]> {
    return this.get<IShiftSession[]>(
      `${this.ShiftSessionsApiAddress}shift/${shiftId}`,
    ).then((response) => response.data.data);
  }

  static createShiftSession(
    session: Partial<IShiftSession>,
  ): Promise<IShiftSession> {
    if (!session.shift)
      throw new Error("updateShiftEnrolment does not have parameter 'shiftId'");
    return this.put<IShiftSession>(this.ShiftSessionsApiAddress, session).then(
      (response) => response.data.data,
    );
  }

  static updateShiftSession(
    session: Partial<IShiftSession>,
  ): Promise<IShiftSession> {
    if (!session._id)
      throw new Error("updateShiftEnrolment was missing parameter '_id'");
    return this.patch<IShiftSession>(
      this.ShiftSessionsApiAddress + session._id,
      session,
    ).then((response) => response.data.data);
  }

  static archiveShiftSession(sessionId: string): Promise<boolean> {
    return this.delete<null>(this.ShiftSessionsApiAddress + sessionId).then(
      (response) => response.data.success || false,
    );
  }

  static getShiftSessionsForPayment(
    associationId: string,
    startDate?: string,
    endDate?: string
  ): Promise<Array<IShiftSession & { shiftName: string }>> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const queryString = params.toString();
    const url = `${this.ShiftSessionsApiAddress}payment/association/${associationId}${queryString ? '?' + queryString : ''}`;

    return this.get<Array<IShiftSession & { shiftName: string }>>(url)
      .then((response) => response.data.data);
  }

  static getSessionAppointments(sessionId: string): Promise<{ data: any[], persons?: any[] }> {
    return this.get<any[]>(
      `${this.ShiftSessionsApiAddress}${sessionId}/appointments`,
    ).then((response) => response.data);
  }

  static hasElevatedShiftPrivileges(sessionId: string, associationId: string): Promise<boolean> {
    return this.get<{ canEdit: boolean }>(
      `${this.ShiftSessionsApiAddress}${sessionId}/can-edit?associationId=${associationId}`,
    ).then((response) => response.data.data.canEdit);
  }

  static updatePaymentStatus(
    sessionId: string,
    paymentStatus: 'unpaid' | 'partial' | 'paid'
  ): Promise<IShiftSession> {
    return this.patch<IShiftSession>(
      `${this.ShiftSessionsApiAddress}${sessionId}/payment-status`,
      { paymentStatus }
    ).then((response) => response.data.data);
  }
}
